var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListGrid = function SvgListGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 22H19c-.5 0-.9-.4-.9-.9v-3.2c0-.5.4-.9.9-.9h4.1c.5 0 .9.4.9.9v3.2c0 .5-.4.9-.9.9zM31.1 22H27c-.5 0-.9-.4-.9-.9v-3.2c0-.5.4-.9.9-.9h4.1c.5 0 .9.4.9.9v3.2c-.1.5-.4.9-.9.9zM23.1 29H19c-.5 0-.9-.4-.9-.9v-3.2c0-.5.4-.9.9-.9h4.1c.5 0 .9.4.9.9v3.2c0 .5-.4.9-.9.9zM31.1 29H27c-.5 0-.9-.4-.9-.9v-3.2c0-.5.4-.9.9-.9h4.1c.5 0 .9.4.9.9v3.2c-.1.5-.4.9-.9.9z"
  })));
};
export default SvgListGrid;